var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHarshAcceleration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#18303e;stroke-linecap:round;stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Harsh Acceleration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20,26.9a2,2,0,0,1,.4-3l7.1-4a1.4,1.4,0,0,1,2.1.9L30,22Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "23.9 27.8 22.7 25.6 22.7 25.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "28 27.8 26.3 25.3 26.9 23.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23,
    y1: 27.8,
    x2: 29.4,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.4,24.1l6.4-3.3c1.5-.8,3.8-.5,5.8-1.5a26,26,0,0,0,5-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.2,18.8a6.8,6.8,0,0,0,2.2,5.3l.9,2.4L15,24.2V23.1l1.4-.7c1.4-.7,3.8-.4,5.8-1.5s4-3.5,4.8-4.4.2-.4.2-.7h0c-.4-1.6-2-2.4-3.2-1.6l-.3.2a7.8,7.8,0,0,1-5.4,1.1,17.8,17.8,0,0,1-5.6-1.8S11.5,18.5,7.2,18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20,15.6A2.6,2.6,0,0,1,18.3,18c-1.7.9-1.8,1.2-2.1,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.1,15.1s.5,2.3,1.6,2.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.3,
    y1: 14.5,
    x2: 13.8,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16,
    y1: 15,
    x2: 15.5,
    y2: 16.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.6,
    y1: 15.4,
    x2: 17.2,
    y2: 16.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.8,18.7a7.8,7.8,0,0,1-.6-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.2,13.4a1.8,1.8,0,0,0,1.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2,8l4.1,8.3a.7.7,0,0,0,1.1.3l4.1-3.3a1.1,1.1,0,0,0,.3-1.1l-4-8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 10.7,
    y1: 10.3,
    x2: 5.3,
    y2: 14.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "17.3 8 15.7 9.2 14.1 10.5 15.2 8 14.1 5.4 15.7 6.7 17.3 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "22.3 8 20.3 9.5 18.4 11.1 19.8 8 18.4 4.8 20.3 6.4 22.3 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.8 8 25.5 9.8 23.2 11.7 24.9 8 23.2 4.2 25.5 6.1 27.8 8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarshAcceleration);
export default __webpack_public_path__ + "static/media/harsh_acceleration.e33d11fe510e99888ac4128c3ce74519.svg";
export { ForwardRef as ReactComponent };